import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../store';
import { GatesData, GateType } from '../types';
import merge from 'deepmerge'
import { openCloseGates, openCloseGate } from './gatesAPI';

export interface GatesState {
    gates: GateType[],
    status?: string,
    loading?: boolean,
    gateLoading?: boolean,
    selectedGate?: number;
}

const initialState: GatesState = {
    gates: GatesData,
    status: 'idle',
    loading: false,
    gateLoading: false,
    selectedGate: 0

};

export const handleCloseOpenGatesAsync = createAsyncThunk(
    'gate/openCloseGates',
    async (closeAll: boolean, { getState }) => {
        const { gates } = getState() as { gates: GatesState };

        const response = await openCloseGates(gates.gates, closeAll);
        return response.data;
    }
);
export const openCloseGGateAsync = createAsyncThunk(
    'gate/openCloseGate',
    async (gateId: number, { getState }) => {
        const { gates } = getState() as { gates: GatesState };

        const response = await openCloseGate(gates.gates, gateId);
        return response.data;
    }
);

export const GatesSlicer = createSlice({
    name: 'gates',
    initialState,
    reducers: {
        lockUnLockDoor: (state, action: PayloadAction<{ doorId: number, isLocked: boolean }>) => {
            state.gateLoading = true

        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(handleCloseOpenGatesAsync.pending, (state) => {
                state.loading = true
                state.status = 'loading';
            })
            .addCase(handleCloseOpenGatesAsync.fulfilled, (state, action) => {
                state.status = 'idle';
                state.loading = false
                state.gates = action.payload
            })
            .addCase(handleCloseOpenGatesAsync.rejected, (state) => {
                state.status = 'failed';
            }).addCase(openCloseGGateAsync.pending, (state, action) => {
                state.gateLoading = true
                state.selectedGate = action?.meta?.arg
            }).addCase(openCloseGGateAsync.fulfilled, (state, action) => {
                state.gateLoading = false
                state.gates = action.payload
            })
    },

});

export const { lockUnLockDoor } = GatesSlicer.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectGatesData = (state: RootState) => state.gates.gates;
export const selectGateState = (state: RootState) => state.gates;


export default GatesSlicer.reducer;
